import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/NotificationOn.svg'

export const IconNotificationOn = IconSVG as IconComponent
